import { render, staticRenderFns } from "./C.vue?vue&type=template&id=1a4c0db6&scoped=true&"
import script from "./C.vue?vue&type=script&lang=js&"
export * from "./C.vue?vue&type=script&lang=js&"
import style0 from "./C.vue?vue&type=style&index=0&id=1a4c0db6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4c0db6",
  null
  
)

export default component.exports